export const BEARER_TOKEN = 'bearer-token';
